<template>
  <div
    class="flex w-full items-center justify-center"
    :style="loadingHeight"
    v-if="props.isLoading"
  >
    <!--    <BcLottie-->
    <!--      :width="parseWidth"-->
    <!--      :height="parseWidth"-->
    <!--      :path="loadingLottiePath"-->
    <!--    />-->
    <Spinner
      :width="parseWidth"
      :height="parseWidth"
    />
  </div>
  <slot v-else />
</template>
<script setup lang="ts">
import Spinner from '~/components/loading/Spinner.vue'

type LoadingProps = {
  isLoading: boolean
  height: number | string
  width?: number | string
}

const props = withDefaults(defineProps<LoadingProps>(), {
  width: 32,
  color: 'theme'
})

const parseWidth = computed(() => {
  if (typeof props.width === 'string' && props.width.includes('px')) {
    return props.width
  }
  return `${props.width}px`
})

const loadingHeight = computed(() => {
  if (typeof props.height === 'string' && props.height.includes('px')) {
    return {
      height: props.height
    }
  }
  return {
    height: `${props.height}px`
  }
})

const loadingLottiePath = computed(() => {
  const path = 'https://globalstatic.xangle.io/lottie'

  // if (props.color === 'white' || darkMode.value === 'dark')
  //   return `${path}/processing-white.json`

  return `${path}/processing.json`
})
</script>


<style scoped lang="scss">

</style>